import { ThoughtChain } from "@ant-design/x";
import { Divider, Flex, Spin, Typography } from "antd";
import { useEffect, useState } from "react";
import { useToken } from "../../hooks/useToken";
import { EMessageRole, TMessage, TSession } from "../../models/ai.model";
import { useTheme } from "../../providers/ThemeProvider";
import { getMessages, getSessions } from "../../services/ai.service";
import { TResponse } from "../../services/apiWorker";
import { formatDate } from "../../utils/date";

export function SettingsConversationalHistory() {
  const { token } = useToken();
  const { message } = useTheme();
  const [isLoading, setLoading] = useState<boolean>(true);
  const [sessions, setSessions] = useState<TResponse<TSession>>(TResponse);

  useEffect(() => {
    getSessions({
      onSuccess: (data) => {
        setSessions(data);
      },
      onError: () => {
        setLoading(false);
        message.error("Failed to load sessions");
      },
    });
  }, []);

  return (
    <Flex
      style={{
        width: "100%",
        flexDirection: "column",
      }}
    >
      <Flex
        style={{
          flexDirection: "column",
          width: "900px",
          maxWidth: "100%",
          margin: "0 auto",
        }}
      >
        <Typography
          style={{
            fontSize: token.fontSizeHeading4,
          }}
        >
          Conversational History
        </Typography>
        <Divider />

        <ThoughtChain
          items={sessions.content.map((session) => {
            return {
              title: session.name,
              description: formatDate(new Date(session.createdAt)),
              content: (
                <SettingsConversationalHistorySession sessionId={session.id} />
              ),
            };
          })}
          collapsible
        />
      </Flex>
    </Flex>
  );
}

function SettingsConversationalHistorySession({
  sessionId,
}: {
  sessionId: string;
}) {
  const [isLoading, setLoading] = useState<boolean>(true);
  const [messages, setMessages] = useState<TResponse<TMessage>>(TResponse);

  useEffect(() => {
    getMessages({
      sessionId,
      onSuccess: (data) => {
        setMessages({
          ...data,
          content: data.content.reverse(),
        });
        setLoading(false);
      },
      onError: (error) => {
        setLoading(false);
      },
    });
  }, [sessionId]);

  return (
    <>
      {isLoading && <Spin />}
      {messages.content.length > 0 && (
        <ThoughtChain
          items={messages.content.map((message, index) => {
            return {
              title:
                (message.role == EMessageRole.USER ? "User" : "Assistant") +
                (index == 0 ? " - Lastest message" : ""),
              description: formatDate(new Date(message.createdAt)),
              content: <Typography>{message.content?.text || ""}</Typography>,
            };
          })}
          collapsible
        />
      )}

      {!isLoading && messages.content.length == 0 && (
        <Typography
          style={{
            fontSize: "14px",
            color: "#888",
          }}
        >
          No messages found for this session.
        </Typography>
      )}
    </>
  );
}
